import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';

import { listCardSizeStyles } from './styles';

const ListCard: React.FC<BaseCard.BaseCardProps> = (props) => {
  const { children, content, className, ...rest } = props;
  const { isMobile } = useScreen();

  return (
    <BaseCard.Provider
      // ideally we should apply listCardMobileSizeStyles for mobile but
      // because mobiles can vary in screen sizes a lot so we can't apply a specific width.
      className={cn(className, 'group', !isMobile ? listCardSizeStyles : undefined)}
      content={content}
      direction="col"
      {...rest}>
      {children}
    </BaseCard.Provider>
  );
};

export default ListCard;
